import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';
import { parseDomain } from './domainHelpers';

export function getAppVersion(analyticsSDKConfig: any) {
    return analyticsSDKConfig.appInfo?.version;
}

export function buildBundleId(analyticsSDKConfig: any) {
    const country = analyticsSDKConfig?.appInfo?.country || 'unknown';
    const domain = parseDomain(window.location.hostname).origin;
    return `${country}.${domain}.web`;
}

// adapted from from vue-analytics-plugin/index.js as in 02/05/2025
export function getPlatform() {
    return isMobileLayout() ? 'web_mobile' : 'web_desktop';
}
